var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "header-component contrast elevation-2",
      class: { "px-1": !_vm.isDesktop },
    },
    [
      !_vm.isDesktop && _vm.haveNavBar
        ? _c("div", [
            _c(
              "div",
              { staticClass: "px-2", on: { click: _vm.toggleSidebar } },
              [_c("BurgerIcon", { attrs: { active: _vm.mobileNavOpen } })],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isDesktop
        ? _c(
            "RouterLink",
            {
              staticClass: "logo-container px-4",
              attrs: { to: { name: _vm.BUCKETS_PAGE } },
            },
            [_c("DynamicLogo", { staticClass: "logo" })],
            1
          )
        : _c(
            "RouterLink",
            {
              staticClass: "logo-mobile-container",
              attrs: { to: { name: _vm.BUCKETS_PAGE } },
            },
            [
              _c("DynamicLogo", {
                staticClass: "logo-mobile",
                attrs: { noText: "" },
              }),
            ],
            1
          ),
      _vm._v(" "),
      _vm.isBucketsPage && _vm.isDesktop
        ? _c("div", { staticClass: "navigation-container" }, [_vm._m(0)])
        : _vm._e(),
      _vm._v(" "),
      _vm.notifications.length
        ? _c(
            "div",
            { staticClass: "notifications-container" },
            _vm._l(_vm.notifications, function (notification, index) {
              return _c("KmTooltip", { key: index, attrs: { bottom: "" } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "nav-to",
                        rawName: "v-nav-to",
                        value: notification.link,
                        expression: "notification.link",
                      },
                    ],
                    staticClass: "notification ma-2",
                    class: { clickable: Boolean(notification.link) },
                    attrs: { slot: "activator" },
                    slot: "activator",
                  },
                  [
                    _c("VIcon", [
                      _vm._v(
                        "\n          " +
                          _vm._s(notification.icon) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "exclamation" }, [_vm._v(" ! ")]),
                  ],
                  1
                ),
                _vm._v("\n      " + _vm._s(notification.message) + "\n    "),
              ])
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("VSpacer"),
      _vm._v(" "),
      _vm.isBucketsPage && _vm.currentPlan && _vm.isDesktop
        ? _c("div", { staticClass: "bucket-meta-data-container mx-2" }, [
            _vm._v("\n    " + _vm._s(_vm.processRatioString) + "\n\n    "),
            _vm.limitReached === true
              ? _c(
                  "span",
                  [
                    _c(
                      "VBtn",
                      {
                        attrs: { color: "warning", small: "" },
                        on: {
                          click: function ($event) {
                            return _vm.redirectToBilling()
                          },
                        },
                      },
                      [
                        _vm._v("\n        Upgrade\n        "),
                        _c("VIcon", [_vm._v("mdi-alert")]),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("span", { staticClass: "ml-2" }, [
              _vm._v("\n      " + _vm._s(_vm.currentPlan.name) + "\n    "),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isBucketsPage &&
      _vm.isUserSuperAdmin &&
      !_vm.isDedicated &&
      _vm.isDesktop
        ? _c(
            "VBtn",
            {
              staticClass: "ma-0 mr-2",
              attrs: {
                small: "",
                color: "primary",
                target: "_blank",
                href: _vm.backOfficeURL,
              },
            },
            [
              _vm._v("\n    BO\n    "),
              _c("KmIcon", {
                staticClass: "ml-2",
                attrs: { name: "km-icon-external-link", size: 16 },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isBucketsPage &&
      _vm.currentPlan &&
      _vm.currentPlan.name !== "free" &&
      _vm.$store.getters.currentAppType === _vm.BACKEND_APP_TYPE &&
      _vm.isDesktop
        ? _c(
            "Menu",
            { attrs: { closeOnContentClick: false } },
            [
              _c(
                "VBtn",
                {
                  staticClass: "ma-0 mr-2",
                  attrs: { slot: "activator", small: "", color: "primary" },
                  on: { click: _vm.onConnectClick },
                  slot: "activator",
                },
                [
                  _c("span", [_vm._v("Connect")]),
                  _vm._v(" "),
                  _c("VIcon", { staticClass: "ml-2", attrs: { size: 20 } }, [
                    _vm._v(" add_circle_outline "),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("LinkInstructions", {
                staticClass: "pa-3 link-instructions-navbar",
                attrs: { disableTitle: "true" },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isDedicated
        ? _c(
            "Button",
            {
              attrs: { slot: "activator", small: !_vm.isDesktop },
              on: { click: _vm.onSearchDoc },
              slot: "activator",
            },
            [_c("KmIcon", { attrs: { size: 28, name: "km-icon-search" } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isBucketsPage
        ? _c(
            "Menu",
            { attrs: { "data-km-tests": "settings-menu" } },
            [
              _c(
                "Button",
                {
                  attrs: { slot: "activator", small: !_vm.isDesktop },
                  slot: "activator",
                },
                [_c("KmIcon", { attrs: { name: "km-icon-settings" } })],
                1
              ),
              _vm._v(" "),
              _c("BucketSettingsEntries"),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "Menu",
        [
          _c(
            "Button",
            {
              attrs: { slot: "activator", small: !_vm.isDesktop },
              slot: "activator",
            },
            [
              _c("VAvatar", { attrs: { size: 28 } }, [
                _c("img", {
                  attrs: {
                    src: _vm.getGravatarUrl(_vm.user.email, 28),
                    alt: "gravatar",
                  },
                }),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("UserEntries"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "icon-heartbeat", attrs: { title: "Realtime Updates" } },
      [
        _c("i", { staticClass: "heartbeat material-icons" }, [
          _vm._v("sync_alt"),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }